import React from 'react';
import Scroll from 'react-scroll';
import PropTypes from 'prop-types';
import { ContractTypes } from '../../constants/contract';
import { Modes, OrderTypes, MONTHS, Intents, OrderStatuses } from '../../constants/order';
import Textinput from '../../components/textinput';
import Statusbar from '../../components/statusbar';
import ShowTradedCheckbox from '../../components/showTraded';
import AllowedUsers from '../../components/allowedUsers';
import SelectUser from '../../components/selectUser';
import { getLatestIndexRequest } from '../../services/api';
import {
    isEveryValid,
    getMonthlyQuantity,
    getOrderPopupText,
    getBidPopupText,
    groupItemsBy,
    scrollToError,
    firstError,
} from '../../services/utils';
const { getTradingPeriodEnd } = require('../../../../backend/utils/tradingPeriod_utils');

const TitleByMode = {
    [Modes.CREATE]: 'Create order',
    [Modes.DUPLICATE]: 'Create order',
    [Modes.CREATE_FINALISED]: 'Create finalised contract',
    [Modes.EDIT]: 'Edit order',
    [Modes.EDIT_FINALISED]: 'Edit order',
    [Modes.VIEW]: 'View order',
};

const TRADING_PERIOD_OPTIONS = [
    'JAN',
    'FEB',
    'MAR',
    'Q1',
    'APR',
    'MAY',
    'JUN',
    'Q2',
    'JUL',
    'AUG',
    'SEP',
    'Q3',
    'OCT',
    'NOV',
    'DEC',
    'Q4',
];
const ORDER_TYPES = [OrderTypes.REGULAR, OrderTypes.DH_BROKER, OrderTypes.DH_GHOST];
const CONTRACT_TYPES = [ContractTypes.OTC, ContractTypes.CME, ContractTypes.PHYSICAL];

const now = new Date();

const shortYear = parseInt(new Date().getFullYear().toString().substr(-2), 10);
const tradingPeriodYearsBroker = [];
for (let year = shortYear - 2; year < shortYear + 3; year += 1) {
    //2 years into the future, 2 in the past
    tradingPeriodYearsBroker.push(year);
}

const tradingPeriodYears = [];
for (let year = shortYear; year < shortYear + 3; year += 1) {
    //2 years into the future, 0 in the past
    tradingPeriodYears.push(year);
}

const getQuantityIncrements = productMaxSize => {
    if (productMaxSize && productMaxSize <= 5000) {
        return [500, 1000, 2000];
    }

    return [1500, 3000, 5000];
};

class SingleOrder extends React.Component {
    constructor(props) {
        super(props);

        this.initialState = {
            product_id: '',
            creator_id: '',
            contract_type: '',
            creator_behalf_of_id: '',
            accepted_by_behalf_of_id: '',
            trading_period: '',
            trading_period_prefix: '',
            trading_period_interval: '',
            trading_period_year: '',
            trading_period_custom: '',
            last_edit_user: '',
            quantity: '',
            currency_id: '',
            intent: '',
            price: '',
            type: OrderTypes.REGULAR,
            notification_type: 0,
            units_name: '',
            expiry_time_left: '',
            status: null,
            is_custom_timeframe: false,
            show_traded: false,
            allowed_users: [],
            filter_users_collapsed: false,
            validation: {
                trading_period: true,
                expiry_time_left: false,
                quantity: false,
                price: false,
                type: true,
                creator_behalf_of_id: false,
                accepted_by_behalf_of_id: false,
                intent: false,
            },
            submitCliked: false,
            currentProduct: {},
            statusbar: {
                visible: false,
                data: {},
                params: {},
            },
        };

        this.state = this.initialState;
        this.is_behalf_fetched = false;

        this.order_types = ORDER_TYPES;
    }

    refreshBehalfUsers = (params = {}, refresh) => {
        const { currentUser, isVisible } = this.props;
        if ((currentUser.is_superuser || currentUser.is_admin) && isVisible && (!this.is_behalf_fetched || refresh)) {
            this.is_behalf_fetched = true;
            this.props.getBehalfUsers(params);
            this.props.getBehalfUsersExtra(params);
            this.setState({
                ...this.state,
                creator_behalf_of_id: this.initialState.creator_behalf_of_id,
                accepted_by_behalf_of_id: this.initialState.accepted_by_behalf_of_id,
                validation: {
                    ...this.state.validation,
                    creator_behalf_of_id: this.initialState.validation.creator_behalf_of_id,
                    accepted_by_behalf_of_id: this.initialState.validation.accepted_by_behalf_of_id,
                },
            });
        }
    };

    componentDidMount() {
        const curYear = now.getFullYear().toString().substring(2);
        const curMonth = MONTHS[now.getMonth()];
        const intent = [Modes.CREATE_FINALISED, Modes.EDIT_FINALISED].includes(this.props.mode) ? Intents.BUY : '';
        this.initialState = {
            ...this.initialState,
            trading_period: `${curMonth} ${curYear}`,
            trading_period_interval: curMonth,
            trading_period_year: curYear,
            trading_period_prefix: '-',
            intent,
        };
        this.setState(this.initialState, () => {
            this.fillFormWithProps(this.props, this.refreshBehalfUsers, this.refreshUsersWithNotifications);
        });
    }

    refreshUsersWithNotifications = params => {
        const { currentUser, mode } = this.props;
        if (
            (currentUser.is_admin || currentUser.is_superuser) &&
            (mode === Modes.CREATE || mode === Modes.EDIT || mode === Modes.DUPLICATE)
        ) {
            this.props.getUsersWithNotification(params, users => {
                this.setState({ allowed_users: users.map(user => user.id) });
            });
        }
    };

    buttonClick = (mode, id) => {
        const { behalfUsers, behalfUsersExtra, currentUser, showPopup } = this.props;
        let popupTextAfter;
        const isSuperUser = !!currentUser.is_superuser || !!currentUser.is_admin;

        const {
            currency_id,
            product_id,
            creator_id,
            creator_behalf_of_id,
            accepted_by_behalf_of_id,
            trading_period_prefix,
            trading_period,
            trading_period_custom,
            is_custom_timeframe,
            quantity,
            price,
            intent,
            units_name,
            currentProduct,
            type,
            notification_type,
            allowed_users,
        } = this.state;
        const expiry_time_left = this.state.expiry_time_left === 'null' ? null : +this.state.expiry_time_left;

        const isCME = currentProduct.contract_type === ContractTypes.CME;

        const getBehalfValue = value => {
            if (isSuperUser) {
                return value ? +value : null;
            }

            return null;
        };

        const popupTextProps = {
            ...this.state,
            expiry_time_left,
            allFreights: this.props.freights,
        };

        const popupText = getOrderPopupText(
            currentUser,
            currentProduct,
            behalfUsers,
            behalfUsersExtra,
            mode,
            is_custom_timeframe,
            popupTextProps,
        );

        if (mode === Modes.DELETE) {
            return this.props.deleteOrder(id, popupText);
        }

        const newValidation = {
            ...this.state.validation,
            creator_behalf_of_id:
                mode === Modes.CREATE_FINALISED || isSuperUser || mode === Modes.EDIT_FINALISED
                    ? this.state.validation.creator_behalf_of_id
                    : true,
            accepted_by_behalf_of_id:
                mode === Modes.CREATE_FINALISED || mode === Modes.EDIT_FINALISED
                    ? this.state.validation.accepted_by_behalf_of_id
                    : true,
            expiry_time_left:
                mode === Modes.CREATE_FINALISED || mode === Modes.VIEW || mode === Modes.EDIT_FINALISED
                    ? true
                    : this.state.validation.expiry_time_left,
            intent:
                mode === Modes.CREATE_FINALISED || mode === Modes.VIEW || mode === Modes.EDIT_FINALISED
                    ? true
                    : this.state.validation.intent ||
                      this.state.intent === Intents.BUY ||
                      this.state.intent === Intents.SELL,
        };

        this.setState({
            ...this.state,
            submitCliked: true,
            validation: newValidation,
        });

        const isValid = isEveryValid(newValidation);
        const errorField = firstError(newValidation);

        if (isValid) {
            let title = 'CREATED!';
            const requestArgs = {
                product_id,
                creator_id,
                trading_period_prefix,
                trading_period: is_custom_timeframe ? trading_period_custom : trading_period,
                is_custom_timeframe,
                quantity: +quantity,
                currency_id,
                intent,
                price: +price,
                units_name,
                expiry_time_left,
                type,
                status: null,
                show_traded: null,
                creator_behalf_of_id: getBehalfValue(creator_behalf_of_id),
                accepted_by_behalf_of_id: getBehalfValue(accepted_by_behalf_of_id),
            };

            if (type !== OrderTypes.REGULAR) {
                requestArgs.notification_type = +notification_type;
            }
            if (
                isSuperUser &&
                (mode === Modes.CREATE || mode === Modes.EDIT || mode === Modes.DUPLICATE) &&
                (type === OrderTypes.REGULAR || requestArgs.notification_type < 3) &&
                this.state.status !== OrderStatuses.CLOSED
            ) {
                requestArgs.allowed_users = allowed_users;
            }
            if (mode === Modes.EDIT) {
                requestArgs.id = id;
                title = 'Your order was updated as follows:';
            }
            if (mode === Modes.CREATE_FINALISED) {
                requestArgs.show_traded = this.state.show_traded;
                const params = {
                    product_short_name: currentProduct.short_name,
                    units_name: currentProduct.units_name,
                    contract_type: currentProduct.contract_type,
                    allFreights: this.props.freights,
                    freights: currentProduct.freights,
                    ...requestArgs,
                };
                if (isCME) {
                    title = 'YOUR ORDER HAS BEEN RECEIVED';
                } else {
                    title = 'ORDER RECEIVED!';
                }

                popupTextAfter = getBidPopupText(
                    params,
                    currentUser,
                    behalfUsers,
                    behalfUsersExtra,
                    'success-finalised',
                );
            }
            if (mode === Modes.EDIT_FINALISED) {
                requestArgs.id = id;
                requestArgs.show_traded = this.state.show_traded;
                requestArgs.status = this.state.status;
                title = 'Your order was updated as follows:';
            }
            this.props.manageOrder(mode, requestArgs, title, popupText, () => null, popupTextAfter);
        } else {
            showPopup({
                title: 'Error',
                content: 'Please make sure all the information is correct and try again.',
                buttonText: 'Dismiss',
            });
            scrollToError(errorField);
        }
    };

    buttonQuantityClick(value) {
        this.setState(state => ({ quantity: state.quantity + parseInt(value, 10) }));
        /*
        let stateProps = {};
        let validationValue = this.state.quantity + parseInt(value);
        let validationName = 'quantity';
        stateProps = {
            validationName: validationValue
        }
        this.setState(stateProps, () => {
            this.validateField(validationName, validationValue);
        });
        */
    }

    handleChange = e => {
        const { name, type } = e.target;
        const value = type === 'checkbox' ? e.target.checked : e.target.value;
        const { products, mode } = this.props;
        const { currentProduct, accepted_by_behalf_of_id, creator_behalf_of_id, is_custom_timeframe } = this.state;

        let stateProps = {};
        let validationName = name;
        let validationValue = value;

        if (mode === Modes.VIEW) {
            return false;
        }

        switch (name) {
            case 'product_id':
                let product = this.getCurrentProduct(value);
                this.currentProduct = product;

                this.setStatusbar(value, product.currency_id, product.contract_type, product.freights);
                this.refreshBehalfUsers(
                    {
                        market_id: product.market_id,
                        product_id: value,
                    },
                    true,
                );
                this.refreshUsersWithNotifications({ product_id: value });

                stateProps = {
                    currentProduct: product,
                    product_id: +value,
                    contract_type: product.contract_type,
                    currency_id: product.currency_id,
                    units_name: product.units_name,
                    creator_behalf_of_id: this.initialState.creator_behalf_of_id,
                    validation: {
                        ...this.state.validation,
                        creator_behalf_of_id: this.initialState.validation.creator_behalf_of_id,
                        accepted_by_behalf_of_id: this.initialState.validation.accepted_by_behalf_of_id,
                    },
                };

                if (product.contract_type !== ContractTypes.PHYSICAL && is_custom_timeframe) {
                    stateProps = {
                        ...stateProps,
                        is_custom_timeframe: this.initialState.is_custom_timeframe,
                        trading_period_custom: this.initialState.trading_period_custom,
                        trading_period: this.initialState.trading_period,
                        trading_period_prefix: this.initialState.trading_period_prefix,
                        trading_period_interval: this.initialState.trading_period_interval,
                        trading_period_year: this.initialState.trading_period_year,
                        validation: {
                            ...stateProps.validation,
                            trading_period: this.initialState.validation.trading_period,
                        },
                    };
                }
                if (product.contract_type !== ContractTypes.PHYSICAL) {
                    stateProps = {
                        ...stateProps,
                        trading_period_prefix: '-',
                        trading_period: this.initialState.trading_period,
                        trading_period_interval: this.initialState.trading_period_interval,
                        trading_period_year: this.initialState.trading_period_year,
                    };
                }
                break;
            case 'is_custom_timeframe':
                let { trading_period_year, trading_period_interval, trading_period_custom, trading_period } =
                    this.state;
                let trading_period_temp = `${trading_period_interval} ${trading_period_year}`;

                stateProps = {
                    trading_period: value ? trading_period_custom : trading_period_temp,
                    is_custom_timeframe: value,
                };
                validationName = 'trading_period';
                validationValue = value ? trading_period_custom : trading_period_temp;
                break;
            case 'trading_period_custom':
                stateProps = {
                    trading_period_custom: value,
                    trading_period_prefix: '-',
                };
                validationName = 'trading_period';
                break;
            case 'trading_period_interval':
                stateProps = {
                    trading_period: `${value} ${this.state.trading_period_year}`,
                    trading_period_interval: value,
                };
                break;
            case 'trading_period_year':
                stateProps = {
                    trading_period: `${this.state.trading_period_interval} ${value}`,
                    trading_period_year: value,
                };
                break;
            case 'intent':
                stateProps = {
                    intent: value,
                };
                break;
            case 'quantity_inc':
                validationValue =
                    (Number.isNaN(parseInt(this.state.quantity, 10)) ? 0 : parseInt(this.state.quantity, 10)) +
                    parseInt(value, 10);
                validationName = 'quantity';
                stateProps = {
                    quantity: validationValue,
                };
                break;
            case 'trading_period_prefix':
                if (value === '1H' || value === '2H' || value === '-') {
                    const curYear = now.getFullYear().toString().substring(2);
                    const curMonth = MONTHS[now.getMonth()];

                    const tradingInterval = this.state.trading_period_interval
                        ? this.state.trading_period_interval
                        : curMonth;
                    const tradingYear = this.state.trading_period_year ? this.state.trading_period_year : curYear;

                    stateProps = {
                        trading_period: `${tradingInterval} ${tradingYear}`,
                        trading_period_prefix: value,
                        trading_period_year: tradingYear,
                        trading_period_interval: tradingInterval,
                    };
                } else {
                    stateProps = {
                        trading_period_prefix: value,
                    };
                }
                break;

            case 'type':
                stateProps = {
                    type: value,
                    notification_type: value === OrderTypes.REGULAR ? 0 : 3,
                };
                break;
            default:
                stateProps = {
                    [name]: value,
                };
        }

        this.setState(stateProps, () => {
            this.validateField(validationName, validationValue);
        });
    };

    handleChangeSelectUser = (name, value) => {
        const { behalfUsers, behalfUsersExtra, mode } = this.props;
        const { currentProduct } = this.state;

        if (mode === Modes.VIEW) return false;

        if (mode === Modes.CREATE_FINALISED || mode === Modes.EDIT_FINALISED) {
            let list, getBehalfFunc;
            if (name === 'creator_behalf_of_id') {
                list = behalfUsers;
                getBehalfFunc = this.props.getBehalfUsersExtra;
            } else {
                list = behalfUsersExtra;
                getBehalfFunc = this.props.getBehalfUsers;
            }
            let exclude = list.find(item => item.id == value);
            let params = {
                market_id: currentProduct.market_id,
                product_id: currentProduct.id,
            };
            if (exclude) params.company_id = exclude.company_id;

            getBehalfFunc(params);
        }

        this.setState({ [name]: value }, () => {
            this.validateField(name, value);
        });
    };

    changeShowTraded = e => {
        const value = e.target.checked;
        const setValue = () => {
            this.setState({
                show_traded: value,
            });
        };
        const refreshOrder = () => {
            this.props.getOrder(this.state.id, this.props.mode, setValue);
        };
        if (this.props.mode === Modes.CREATE_FINALISED || this.props.mode === Modes.EDIT_FINALISED) {
            this.handleChange(e);
        } else {
            this.props.setShowTraded(this.state.id, value, refreshOrder);
        }
    };

    validateField(fieldName, value) {
        const { min_size, max_size, min_price, max_price } = this.currentProduct;
        const isPhysical = this.state.currentProduct.contract_type === ContractTypes.PHYSICAL;
        const isQuantityValid = val => val >= min_size && val <= max_size;
        const isPriceValid = val => val >= min_price && val <= max_price;
        let isValid;

        switch (fieldName) {
            case 'quantity':
                isValid = isQuantityValid(value);
                break;
            case 'price':
                isValid = isPriceValid(value);
                break;
            case 'trading_period_interval':
            case 'trading_period_year':
            case 'trading_period_prefix':
            case 'trading_period':
                if (!this.state.is_custom_timeframe && this.props.mode !== Modes.EDIT_FINALISED) {
                    let periodEnd = getTradingPeriodEnd(this.state.trading_period_prefix, this.state.trading_period);
                    if (periodEnd) {
                        isValid = periodEnd > now;
                    } else {
                        isValid = true;
                    }
                } else {
                    isValid = value && value.trim() ? true : false;
                }

                fieldName = 'trading_period';
                break;
            default:
                isValid = value && (typeof value !== 'string' || value.trim()) ? true : false;
        }

        if (this.state.validation[fieldName] != undefined) {
            this.setState({
                validation: {
                    ...this.state.validation,
                    [fieldName]: isValid,
                },
            });
        } else if (fieldName == 'product_id') {
            this.setState({
                validation: {
                    ...this.state.validation,
                    quantity: isQuantityValid(this.state.quantity),
                    price: isPriceValid(this.state.price),
                },
            });
        }
    }

    setStatusbar = (product_id, currency, contract_type, freights) => {
        getLatestIndexRequest(product_id)
            .then(response => {
                this.setState({
                    ...this.state,
                    statusbar: {
                        ...this.state.statusbar,
                        visible: true,
                        data: response.data,
                        params: { currency, contract_type, freights },
                    },
                });
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    statusbar: {
                        ...this.state.statusbar,
                        visible: false,
                        data: {},
                        params: {},
                    },
                });
            });
    };

    fillFormWithProps = (props, refreshBehalf, refreshNotificationUsers) => {
        let product_id, creator_id, currency_id, units_name, result, currentProduct;
        const { formData, currentUser } = props;
        const isSuperUser = !!currentUser.is_superuser || !!currentUser.is_admin;
        const fillValidation = {};

        if (props.mode === Modes.CREATE || props.mode === Modes.CREATE_FINALISED) {
            if (props.products && props.products.length) {
                currentProduct = this.getCurrentProduct(
                    formData && formData.product_id ? +formData.product_id : +props.products[0].id,
                );
                product_id = currentProduct.id;
                this.currentProduct = currentProduct;
                currency_id = currentProduct.currency_id;
                units_name = currentProduct.units_name;
                creator_id = props.currentUser ? +props.currentUser.id : '';

                result = {
                    currentProduct,
                    creator_id,
                    currency_id,
                    units_name,
                    ...formData,
                    product_id,
                    validation: this.initialState.validation,
                };
                refreshBehalf({
                    market_id: currentProduct.market_id,
                    product_id,
                });
                refreshNotificationUsers({ product_id });
                this.setStatusbar(product_id, currency_id, currentProduct.contract_type, currentProduct.freights);
            }
        }

        if (
            props.mode === Modes.EDIT ||
            props.mode === Modes.VIEW ||
            props.mode === Modes.EDIT_FINALISED ||
            props.mode === Modes.DUPLICATE
        ) {
            let {
                trading_period_prefix,
                trading_period_interval,
                trading_period_year,
                is_custom_timeframe,
                trading_period_custom,
            } = this.state;
            let units_name = '';
            currentProduct = this.getCurrentProduct(formData.product_id);
            this.currentProduct = currentProduct;

            if (formData.is_custom_timeframe) {
                formData.trading_period_custom = formData.trading_period;
                formData.trading_period_prefix = trading_period_prefix;
                formData.trading_period_interval = trading_period_interval;
                formData.trading_period_year = trading_period_year;
            }

            if (
                !formData.is_custom_timeframe &&
                (formData.trading_period_year === null || formData.trading_period_interval === null) &&
                formData.trading_period_prefix === null
            ) {
                formData.is_custom_timeframe = true;
                formData.trading_period_custom = formData.trading_period;
            }

            units_name = currentProduct.units_name;

            result = {
                currentProduct,
                trading_period_prefix,
                trading_period_interval,
                trading_period_year,
                units_name,
                ...formData,
                creator_behalf_of_id: formData.creator_behalf_of_id || formData.creator_id,
                accepted_by_behalf_of_id: formData.accepted_by_behalf_of_id || formData.accepted_by_id,
                expiry_time_left: props.formData && props.formData.expiry_time === null ? 'null' : '',
            };

            refreshBehalf({
                market_id: currentProduct.market_id,
                product_id: formData.product_id,
            });
            refreshNotificationUsers({ product_id: formData.product_id });
            this.setStatusbar(
                formData.product_id,
                currentProduct.currency_id,
                currentProduct.contract_type,
                currentProduct.freights,
            );

            if (props.mode === Modes.DUPLICATE && !props.currentUser.is_superuser) {
                result = {
                    ...result,
                    creator_id: props.currentUser.id,
                };
            }

            //override the trading period if the prefix is traded/prompt to pass validation
            const tradingPeriod = result.trading_period;
            if (result.trading_period_prefix === 'LOADED' || result.trading_period_prefix === 'PROMPT') {
                result.trading_period = result.trading_period_prefix;
            }
            for (let key in this.state.validation) {
                fillValidation[key] = !!(key in result && result[key]);
            }
            //restore trading period value
            result.trading_period = tradingPeriod;

            result.validation = fillValidation;
        }

        if (!props.currentUser.is_superuser || !props.currentUser.is_admin)
            result.validation.creator_behalf_of_id = true;

        this.setState(result);
    };

    closePopup = e => {
        if (e.target.getAttribute('name') === 'popup-overlay') {
            this.props.hidePopup();
        }
    };

    getCurrentProduct = productId => {
        let { currentUser, products, mode } = this.props;
        const isCMEUser = currentUser.cme_cleared;
        let curProduct = products.find(item => item.id === +productId);

        if (mode === Modes.CREATE && !isCMEUser && curProduct && curProduct.contract_type === ContractTypes.CME) {
            curProduct = products.filter(item => item.contract_type != ContractTypes.CME)[0];
        }
        return curProduct;
    };

    renderProductsSelect = (products, isSuperUser) => {
        let cmeCleared = this.props.currentUser.cme_cleared;
        let markets = this.props.currentUser.markets;

        if (!products || !products.length) {
            return [];
        }

        const renderSuperList = () => {
            return markets.map((market, i) => {
                const marketProducts = products.filter(p => p.market_id == market.id);
                const groups = groupItemsBy(marketProducts, 'contract_type');
                const contracts = CONTRACT_TYPES.filter(contract_type => !!groups[contract_type]);

                return contracts.map(contract_type => (
                    <optgroup label={`${market.name} - ${contract_type}`} key={'markgr' + i + contract_type}>
                        {groups[contract_type].map((product, j) => (
                            <option value={product.id} key={'prod' + j}>
                                {product.short_name} ({product.unit_name}, {product.contract_type})
                            </option>
                        ))}
                    </optgroup>
                ));
            });
        };

        const renderRegularList = () => {
            const groups = groupItemsBy(products, 'contract_type');
            const contracts = CONTRACT_TYPES.filter(contract_type => !!groups[contract_type]);

            return contracts.map(contract_type => (
                <optgroup label={contract_type} key={'ctrgr' + contract_type}>
                    {groups[contract_type].map((item, i) => (
                        <option
                            value={item.id}
                            key={'prod' + i}
                            disabled={!cmeCleared && item.contract_type === ContractTypes.CME}
                        >
                            {item.short_name} ({item.contract_type})
                        </option>
                    ))}
                </optgroup>
            ));
        };

        return (
            <select
                name="product_id"
                onChange={this.handleChange}
                value={this.state.product_id}
                disabled={this.props.mode === Modes.VIEW ? 'disabled' : ''}
            >
                {isSuperUser ? renderSuperList() : renderRegularList()}
            </select>
        );
    };

    renderBehalfOfSelect = (key, titlePrefix) => {
        let isValid = this.state.validation[key],
            { behalfUsers, behalfUsersExtra } = this.props,
            { submitCliked } = this.state;

        const data = key === 'creator_behalf_of_id' || key === 'creator_id' ? behalfUsers : behalfUsersExtra;
        const selectedValue = this.state[key];
        let selectedObject = null;
        const groupedData = groupItemsBy(data, 'companyname');
        const groupedOptions = Object.entries(groupedData).map(group => {
            return {
                label: group[0],
                options: group[1].map(item => {
                    if (selectedValue === item.id) {
                        selectedObject = { label: item.username, value: item.id };
                    }
                    return { label: item.username, value: item.id, company: group[0] };
                }),
            };
        });

        return (
            <div className="field-wrap">
                <div className="popup-label-column">
                    <h3 className={'labelpassive ' + (!isValid && submitCliked ? 'error' : '')}>
                        {titlePrefix} on behalf of *
                    </h3>
                </div>
                <div className="popup-content-column">
                    <Scroll.Element name={key} />
                    <SelectUser
                        groupedOptions={groupedOptions}
                        onChange={selected => this.handleChangeSelectUser(key, selected.value)}
                        selectedValue={selectedObject}
                        className={!isValid && submitCliked ? 'error-select' : ''}
                    />
                </div>
            </div>
        );
    };

    renderBehalfOfSelectBlock = mode => {
        if (mode === Modes.CREATE_FINALISED || mode === Modes.EDIT_FINALISED) {
            return (
                <div>
                    {this.renderBehalfOfSelect(
                        this.state.intent === Intents.BUY ? 'creator_behalf_of_id' : 'accepted_by_behalf_of_id',
                        'Buy',
                    )}
                    {this.renderBehalfOfSelect(
                        this.state.intent === Intents.BUY ? 'accepted_by_behalf_of_id' : 'creator_behalf_of_id',
                        'Sell',
                    )}
                </div>
            );
        }

        return this.renderBehalfOfSelect('creator_behalf_of_id', 'Place order');
    };

    renderCounterParty(mode) {
        const { formData, currentUser } = this.props;
        const { status } = this.state;

        if (mode === Modes.VIEW && status === OrderStatuses.CLOSED) {
            let counterpart = 'CME';
            if (formData.contract_type !== ContractTypes.CME) {
                if (formData.accepted_by_company_id == currentUser.company_id) {
                    counterpart = formData.creator_company_name;
                } else if (formData.creator_company_id == currentUser.company_id) {
                    counterpart = formData.accepted_by_company_name;
                } else {
                    return null;
                }
            } else if (
                formData.accepted_by_company_id != currentUser.company_id &&
                formData.creator_company_id != currentUser.company_id
            ) {
                return null;
            }
            return (
                <div className="field-wrap">
                    <label className="labelactive">Counterparty</label>
                    <p className="paragrah inactive">{counterpart}</p>
                </div>
            );
        }
    }

    renderContractId(mode) {
        const { formData, currentUser } = this.props;

        if (
            formData.accepted_by_company_id != currentUser.company_id &&
            formData.creator_company_id != currentUser.company_id &&
            !(currentUser.is_admin || currentUser.is_superuser)
        ) {
            return null;
        }

        if ((mode === Modes.VIEW || mode === Modes.EDIT_FINALISED) && this.state.status === OrderStatuses.CLOSED) {
            return (
                <div className="field-wrap">
                    <label className="labelactive">Contract id</label>
                    <p className="paragrah inactive">{formData.contract_numbers}</p>
                </div>
            );
        }
    }

    render() {
        let { isVisible, mode, products, currentUser, notificationUsers } = this.props;
        let { submitCliked, status, creator_company_id, is_custom_timeframe } = this.state;
        let readOnly = mode === Modes.VIEW;
        let isEditingFinalized = mode === Modes.EDIT_FINALISED;
        let isSuperUser = !!currentUser.is_superuser || !!currentUser.is_admin;
        let isOwner = currentUser.company_id == creator_company_id;
        let cmeCleared = currentUser.cme_cleared;
        let isPhysical = this.state.currentProduct.contract_type === ContractTypes.PHYSICAL;

        let isPeriodPrefixVisible =
            isPhysical &&
            (this.state.trading_period_interval == null || !this.state.trading_period_interval.startsWith('Q'));
        let isPeriodIntervalVisible =
            !isPhysical || (isPhysical && ['1H', '2H', '-'].includes(this.state.trading_period_prefix));
        let isPeriodYearVisible = isPeriodIntervalVisible;

        let quantityValid = this.state.validation.quantity,
            priceValid = this.state.validation.price,
            expiresValid = this.state.validation.expiry_time_left,
            typeValid = this.state.validation.type,
            intentValid = this.state.validation.intent;

        let tradingYears = tradingPeriodYears;
        if (isSuperUser && isEditingFinalized) {
            tradingYears = tradingPeriodYearsBroker;
        }

        const productMaxSize = this.currentProduct ? this.currentProduct.max_size : null;
        const quantityIncrements = getQuantityIncrements(productMaxSize);

        const title = TitleByMode[mode];

        return (
            <div
                className="order-container generic-popup-container"
                name="popup-overlay"
                style={{ display: isVisible ? 'block' : 'none' }}
                onClick={this.closePopup}
                id="scroll-container"
            >
                <div className="form">
                    <div id="order">
                        <h1 className="order-title">{title}</h1>

                        <div className="field-wrap">
                            <div className="popup-label-column">
                                <h3 className="labelpassive">Product</h3>
                            </div>
                            <div className="popup-content-column">
                                <Scroll.Element name="product_id" />
                                {this.renderProductsSelect(products, isSuperUser)}
                                <Statusbar
                                    statusbar={this.state.statusbar}
                                    inactive={mode === Modes.VIEW}
                                    freights={this.props.freights}
                                />
                            </div>
                        </div>

                        {isPhysical && !readOnly ? (
                            <div className="field-wrap">
                                <div className="popup-label-column">
                                    <h3 className="labelpassive">With custom timeframe</h3>
                                </div>
                                <div className="popup-content-column">
                                    <input
                                        type="checkbox"
                                        name="is_custom_timeframe"
                                        id="is_custom_timeframe"
                                        checked={is_custom_timeframe || false}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        ) : null}
                        {is_custom_timeframe && !readOnly ? (
                            <div className="field-wrap">
                                <div className="popup-label-column">
                                    <h3 className="labelpassive">Trading period(s)</h3>
                                </div>
                                <div className="popup-content-column">
                                    <Textinput
                                        name="trading_period_custom"
                                        scrollName="trading_period"
                                        value={this.state.trading_period_custom || ''}
                                        onChange={this.handleChange}
                                        required={true}
                                        readOnly={readOnly}
                                        invalid={!this.state.validation.trading_period && submitCliked}
                                        type="text"
                                    />
                                </div>
                            </div>
                        ) : null}

                        {!is_custom_timeframe && !readOnly ? (
                            <div className={`field-wrap ${!this.state.validation.trading_period ? 'error' : ''}`}>
                                <div className="popup-label-column">
                                    <h3 className="labelpassive">
                                        Trading period(s)<span className="req">*</span>
                                    </h3>
                                </div>
                                <div className="popup-content-column">
                                    <div className="clearfix">
                                        <select
                                            className="select-side-by-side"
                                            name="trading_period_prefix"
                                            value={this.state.trading_period_prefix}
                                            onChange={this.handleChange}
                                            style={{ display: isPeriodPrefixVisible ? 'block' : 'none' }}
                                            disabled={readOnly ? 'disabled' : ''}
                                        >
                                            <option value="LOADED">LOADED</option>
                                            <option value="PROMPT">PROMPT</option>
                                            <option value="-">-</option>
                                            <option value="1H">1H</option>
                                            <option value="2H">2H</option>
                                        </select>
                                        <select
                                            className="select-side-by-side"
                                            name="trading_period_interval"
                                            value={this.state.trading_period_interval}
                                            onChange={this.handleChange}
                                            style={{ display: isPeriodIntervalVisible ? 'block' : 'none' }}
                                            disabled={readOnly ? 'disabled' : ''}
                                        >
                                            {TRADING_PERIOD_OPTIONS.map(m => (
                                                <option key={m} value={m}>
                                                    {m}
                                                </option>
                                            ))}
                                        </select>
                                        <select
                                            className="select-side-by-side"
                                            name="trading_period_year"
                                            value={this.state.trading_period_year}
                                            onChange={this.handleChange}
                                            style={{ display: isPeriodYearVisible ? 'block' : 'none' }}
                                            disabled={readOnly ? 'disabled' : ''}
                                        >
                                            {tradingYears.map(m => (
                                                <option key={m} value={m}>
                                                    {m}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {!this.state.validation.trading_period &&
                                    this.state.trading_period.indexOf('Q') > -1 ? (
                                        <div className="field-note" style={{ marginTop: 5 }}>
                                            You can't create an order for a quarterly trading period after the first
                                            month has passed
                                        </div>
                                    ) : null}
                                    {!this.state.validation.trading_period &&
                                    this.state.trading_period.indexOf('Q') === -1 ? (
                                        <div className="field-note" style={{ marginTop: 5 }}>
                                            You can't create an order for a trading period that has passed
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}

                        {readOnly ? (
                            <div className="field-wrap">
                                <div className="popup-label-column">
                                    <h3 className="labelpassive">
                                        Trading period(s)<span className="req">*</span>
                                    </h3>
                                </div>
                                <div className="popup-content-column">
                                    <Scroll.Element name="trading_period" />
                                    <p className="paragrah inactive">{this.state.trading_period}</p>
                                </div>
                            </div>
                        ) : null}

                        {mode !== Modes.CREATE_FINALISED &&
                        (mode !== Modes.VIEW || status !== OrderStatuses.CLOSED) &&
                        mode !== Modes.EDIT_FINALISED ? (
                            <div className="field-wrap">
                                <div className="popup-label-column">
                                    <h3 className={'labelpassive ' + (!intentValid && submitCliked ? 'error' : '')}>
                                        Intent
                                    </h3>
                                </div>
                                <div className="radio-button-container">
                                    <input
                                        type="radio"
                                        onChange={this.handleChange}
                                        id="intent_buy"
                                        name="intent"
                                        value="BUY"
                                        disabled={readOnly ? 'disabled' : ''}
                                        checked={this.state.intent === Intents.BUY}
                                    />
                                    <div className={'labelpassive ' + (!intentValid && submitCliked ? 'error' : '')}>
                                        Buy
                                    </div>

                                    <input
                                        type="radio"
                                        onChange={this.handleChange}
                                        id="intent_sell"
                                        name="intent"
                                        value="SELL"
                                        disabled={readOnly ? 'disabled' : ''}
                                        checked={this.state.intent === Intents.SELL}
                                    />
                                    <div className={'labelpassive ' + (!intentValid && submitCliked ? 'error' : '')}>
                                        Sell
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        <div className="field-wrap">
                            <div className="popup-label-column">
                                <h3 className="labelpassive">
                                    Price<span className="req">*</span>
                                </h3>
                            </div>
                            <div className="popup-content-column">
                                <div className="multi-column-row">
                                    <Textinput
                                        name="price"
                                        value={this.state.price}
                                        onChange={this.handleChange}
                                        readOnly={readOnly}
                                        invalid={!priceValid && submitCliked}
                                        type="number"
                                        inputProcessing="decimalTwoDigits"
                                    />

                                    <div className="column">
                                        <div className={'order-currency ' + (readOnly ? 'muted' : '')}>
                                            {this.state.currency_id}
                                        </div>
                                    </div>

                                    {mode !== Modes.VIEW && this.currentProduct ? (
                                        <div className="input-range">
                                            min - {this.currentProduct.min_price}, max - {this.currentProduct.max_price}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>

                        <div className="field-wrap">
                            <div className="popup-label-column">
                                <h3 className="labelpassive">
                                    Quantity per month in {this.state.units_name} <span className="req">*</span>
                                </h3>
                            </div>
                            <div className="popup-content-column">
                                <div className="quantity-flex-container">
                                    <div className="multi-column-row">
                                        <Textinput
                                            label=""
                                            name="quantity"
                                            value={this.state.quantity}
                                            onChange={this.handleChange}
                                            readOnly={readOnly}
                                            invalid={!quantityValid && submitCliked}
                                            type="number"
                                            inputProcessing="integer"
                                        />
                                        <div className={'input-range ' + (readOnly ? 'muted' : '')}>
                                            {mode !== Modes.VIEW && this.currentProduct
                                                ? `min - ${this.currentProduct.min_size}, max - ${productMaxSize}. `
                                                : null}
                                            <span className="monthly">
                                                {getMonthlyQuantity(false, is_custom_timeframe, this.state)}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="quantity-flex-container">
                                        {mode !== Modes.VIEW
                                            ? quantityIncrements.map((value, index) => {
                                                  return (
                                                      <button
                                                          key={`quantity_inc_${index}`}
                                                          name="quantity_inc"
                                                          onClick={this.handleChange}
                                                          value={value}
                                                          className="button"
                                                      >
                                                          +{value}
                                                      </button>
                                                  );
                                              })
                                            : null}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {!(mode === Modes.CREATE_FINALISED || mode === Modes.VIEW || mode === Modes.EDIT_FINALISED) ? (
                            <div className={`field-wrap ${!expiresValid && submitCliked ? 'error' : ''}`}>
                                <div className="popup-label-column">
                                    <h3 className="labelpassive">
                                        Expires in<span className="req">*</span>
                                    </h3>
                                </div>
                                <div className="popup-content-column">
                                    <Scroll.Element name="expiry_time_left" />
                                    <select
                                        name="expiry_time_left"
                                        onChange={this.handleChange}
                                        value={this.state.expiry_time_left}
                                        disabled={readOnly ? 'disabled' : ''}
                                    >
                                        <option value="">-- choose expiration time --</option>
                                        <option value="null">Good &apos;Til Cancelled</option>
                                        {process.env.NODE_ENV === 'development' ? (
                                            <option value={60}>1 minute</option>
                                        ) : (
                                            ''
                                        )}
                                        <option value={15 * 60}>15 minutes</option>
                                        <option value={30 * 60}>30 minutes</option>
                                        <option value={60 * 60}>1 hour</option>
                                        <option value={120 * 60}>2 hours</option>
                                        <option value={180 * 60}>3 hours</option>
                                        <option value={240 * 60}>4 hours</option>
                                        <option value={300 * 60}>5 hours</option>
                                        <option value={360 * 60}>6 hours</option>
                                    </select>
                                </div>
                            </div>
                        ) : null}

                        {currentUser.is_superuser || currentUser.is_admin
                            ? this.renderBehalfOfSelectBlock(mode)
                            : this.renderCounterParty(mode)}

                        {currentUser.is_admin || currentUser.is_superuser ? (
                            <div className={`field-wrap ${!typeValid && submitCliked ? 'error' : ''}`}>
                                <div className="popup-label-column">
                                    <h3 className="labelpassive">Select order type</h3>
                                </div>
                                <div className="popup-content-column">
                                    <Scroll.Element name="type" />
                                    <select
                                        name="type"
                                        onChange={this.handleChange}
                                        value={this.state.type || this.order_types[0]}
                                        disabled={readOnly ? 'disabled' : ''}
                                    >
                                        {this.order_types.map((item, i) => {
                                            return (
                                                <option disabled="" key={'type' + i} value={item}>
                                                    {item}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        ) : null}

                        {(currentUser.is_admin || currentUser.is_superuser) &&
                        this.state.type !== OrderTypes.REGULAR ? (
                            <div className="field-wrap">
                                <div className="popup-label-column">
                                    <h3 className="labelpassive">Select notifications type</h3>
                                </div>
                                <div className="popup-content-column">
                                    <select
                                        name="notification_type"
                                        onChange={this.handleChange}
                                        value={this.state.notification_type}
                                        disabled={readOnly ? 'disabled' : ''}
                                    >
                                        <option value={0}>Firm</option>
                                        <option value={2}>Interest</option>
                                        <option value={3}>None</option>
                                    </select>
                                </div>
                            </div>
                        ) : null}

                        {this.renderContractId(mode)}

                        {(currentUser.is_admin || currentUser.is_superuser) &&
                        (this.state.notification_type < 3 || this.state.type === OrderTypes.REGULAR) &&
                        status !== OrderStatuses.CLOSED &&
                        (mode === Modes.CREATE || mode === Modes.EDIT || mode === Modes.DUPLICATE) ? (
                            <div className="field-wrap">
                                <a
                                    htmlFor="allowed_users"
                                    className={`label ${
                                        this.state.filter_users_collapsed ? 'icon-open' : 'icon-close'
                                    }`}
                                    onClick={() =>
                                        this.setState({ filter_users_collapsed: !this.state.filter_users_collapsed })
                                    }
                                >
                                    Filter users receiving notifications
                                </a>
                                <AllowedUsers
                                    style={{ display: this.state.filter_users_collapsed ? 'block' : 'none' }}
                                    users={notificationUsers}
                                    allowedUsers={this.state.allowed_users}
                                    onChange={newAllowedUsers => this.setState({ allowed_users: newAllowedUsers })}
                                />
                            </div>
                        ) : null}

                        {isSuperUser &&
                        (mode === Modes.VIEW || mode === Modes.CREATE_FINALISED || mode === Modes.EDIT_FINALISED) ? (
                            <ShowTradedCheckbox value={this.state.show_traded} onChange={this.changeShowTraded} />
                        ) : null}

                        <div className="field-wrap">
                            {mode === Modes.VIEW && status !== OrderStatuses.CLOSED && isOwner ? (
                                <button
                                    onClick={() => this.props.setOrderPopupMode(Modes.EDIT)}
                                    className="button button-block"
                                >
                                    {this.state.intent === Intents.BUY ? 'Edit bid' : 'Edit offer'}
                                </button>
                            ) : null}
                            {mode === Modes.CREATE || mode === Modes.CREATE_FINALISED || mode === Modes.DUPLICATE ? (
                                <button onClick={() => this.buttonClick(mode)} className="button button-block">
                                    Create
                                </button>
                            ) : null}
                            {mode === Modes.EDIT || mode === Modes.EDIT_FINALISED ? (
                                <div className="multi-column-row">
                                    <div className="column">
                                        <button
                                            onClick={() => this.buttonClick(mode, this.state.id)}
                                            className="button button-block"
                                        >
                                            Update
                                        </button>
                                    </div>
                                    <div className="column">
                                        <button
                                            onClick={() => this.buttonClick(Modes.DELETE, this.state.id)}
                                            className="button button-block button-delete"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            ) : null}
                        </div>

                        {isSuperUser &&
                        (mode === Modes.VIEW || mode === Modes.EDIT || mode === Modes.EDIT_FINALISED) ? (
                            <div className={'last-edit-user'}>Last edited by {this.state.last_edit_user}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

SingleOrder.propTypes = {
    isVisible: PropTypes.bool,
    mode: PropTypes.string.isRequired,
    currentUser: PropTypes.shape({
        company_id: PropTypes.number,
        is_admin: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        is_superuser: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        cme_cleared: PropTypes.bool,
        markets: PropTypes.arrayOf(PropTypes.shape({})),
    }).isRequired,
    formData: PropTypes.shape({
        contract_type: PropTypes.string,
        contract_numbers: PropTypes.string,
        accepted_by_company_id: PropTypes.number,
        accepted_by_company_name: PropTypes.string,
        creator_company_id: PropTypes.number,
        creator_company_name: PropTypes.string,
    }).isRequired,
    freights: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    behalfUsers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    behalfUsersExtra: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    notificationUsers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,

    showPopup: PropTypes.func.isRequired,
    hidePopup: PropTypes.func.isRequired,
    getUsersWithNotification: PropTypes.func.isRequired,
    deleteOrder: PropTypes.func.isRequired,
    manageOrder: PropTypes.func.isRequired,
    getOrder: PropTypes.func.isRequired,
    setShowTraded: PropTypes.func.isRequired,
    setOrderPopupMode: PropTypes.func.isRequired,
    getBehalfUsersExtra: PropTypes.func,
    getBehalfUsers: PropTypes.func,
};

SingleOrder.defaultProps = {
    isVisible: false,
    getBehalfUsersExtra: () => {},
    getBehalfUsers: () => {},
};

export default SingleOrder;



// WEBPACK FOOTER //
// ./source/screens/orders/singleOrder.js